import Vue, { PluginObject } from "vue";
import SettingsService, { ThemeSettings } from '@/services/core/SettingsService';

export const ConfigPlugin: PluginObject<{}> =
{
    install(Vue, options)
    {
        let config = SettingsService.getConfig();
        let themes: Record<string, Promise<ThemeSettings>> = {};

        Vue.Config = Vue.prototype.$config = (name: string, throwError: boolean = false): Promise<any> =>
        {
            return new Promise((resolve, reject) =>
            {
                config
                    .then((config) => resolve(config[name] || {}))
                    .catch((reason =>
                    {
                        Vue.$log.error(`Det oppstod en feil under innlasting (${name}).`);
                        throwError ? reject(reason) : resolve(null);
                    }));
            });
        };

        Vue.Theme = Vue.prototype.$theme = (name: string, throwError: boolean = false): Promise<ThemeSettings> =>
        {
            return themes[name] || (themes[name] = new Promise((resolve, reject) =>
            {
                SettingsService.getThemeConfig(name)
                    .then((config) => resolve(config))
                    .catch((reason =>
                    {
                        Vue.$log.error(`Det oppstod en feil under lasting av temainnstillinger (${name}).`);
                        throwError ? reject(reason) : resolve(null);
                    }));
            }));
        };
    }
};

declare module 'vue/types/vue'
{
    interface Vue
    {
        $config: (name: string, throwError?: boolean) => Promise<any>;
        $theme: (name: string, throwError?: boolean) => Promise<ThemeSettings>;
    }
    interface VueConstructor
    {
        Config: (name: string, throwError?: boolean) => Promise<any>;
        Theme: (name: string, throwError?: boolean) => Promise<ThemeSettings>;
    }
}
